import { render, staticRenderFns } from "./WorkspaceFindRelatedDatasetsModal.vue?vue&type=template&id=f2852c5c&scoped=true"
import script from "./WorkspaceFindRelatedDatasetsModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceFindRelatedDatasetsModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceFindRelatedDatasetsModal.vue?vue&type=style&index=0&id=f2852c5c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2852c5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2852c5c')) {
      api.createRecord('f2852c5c', component.options)
    } else {
      api.reload('f2852c5c', component.options)
    }
    module.hot.accept("./WorkspaceFindRelatedDatasetsModal.vue?vue&type=template&id=f2852c5c&scoped=true", function () {
      api.rerender('f2852c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceFindRelatedDatasetsModal.vue"
export default component.exports